import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { HelmetProvider } from 'react-helmet-async';
import rootReducer from "./store";
import './index.css';
import App from './App';

const store = createStore(rootReducer, applyMiddleware(thunk));
const root = ReactDOM.createRoot(document.getElementById('root'));
const helmetContext = {};
root.render(
  <HelmetProvider context={helmetContext}>
    <CookiesProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </CookiesProvider>
  </HelmetProvider>
);